/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BuyerDemandDto,
  BuyerDemandListDto,
  CreateDemandDto,
  CreatePriceDto,
  IndicativePriceListDto,
  MarketControllerListDemandsParams,
  MarketPriceDto,
  MarketPublicControllerGetPriceTimeSeriesParams,
  MarketPublicControllerGetPricesParams,
  MatchListDto,
  PriceTimeSeriesDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Admin/coop_admin only. zarpPerKgMicro is micro-ZARP/kg as a string. Writes an audit row.
 * @summary Record a market price observation (manual ingest)
 */
export const marketControllerCreatePrice = (
    createPriceDto: CreatePriceDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MarketPriceDto>(
      {url: `/market/prices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPriceDto, signal
    },
      );
    }
  


export const getMarketControllerCreatePriceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketControllerCreatePrice>>, TError,{data: CreatePriceDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof marketControllerCreatePrice>>, TError,{data: CreatePriceDto}, TContext> => {

const mutationKey = ['marketControllerCreatePrice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketControllerCreatePrice>>, {data: CreatePriceDto}> = (props) => {
          const {data} = props ?? {};

          return  marketControllerCreatePrice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketControllerCreatePriceMutationResult = NonNullable<Awaited<ReturnType<typeof marketControllerCreatePrice>>>
    export type MarketControllerCreatePriceMutationBody = CreatePriceDto
    export type MarketControllerCreatePriceMutationError = unknown

    /**
 * @summary Record a market price observation (manual ingest)
 */
export const useMarketControllerCreatePrice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketControllerCreatePrice>>, TError,{data: CreatePriceDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketControllerCreatePrice>>,
        TError,
        {data: CreatePriceDto},
        TContext
      > => {

      const mutationOptions = getMarketControllerCreatePriceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Unauthenticated. Aggregates recent observations into low/high/latest micro-ZARP/kg per grade. product defaults to "mango"; grade is optional (A|B|C). 400 on a bad grade.
 * @summary PUBLIC: indicative price band per (product, grade)
 */
export const marketPublicControllerGetPrices = (
    params?: MarketPublicControllerGetPricesParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<IndicativePriceListDto>(
      {url: `/market/prices`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getMarketPublicControllerGetPricesQueryKey = (params?: MarketPublicControllerGetPricesParams,) => {
    return [
    `/market/prices`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMarketPublicControllerGetPricesQueryOptions = <TData = Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError = unknown>(params?: MarketPublicControllerGetPricesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketPublicControllerGetPricesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>> = ({ signal }) => marketPublicControllerGetPrices(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MarketPublicControllerGetPricesQueryResult = NonNullable<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>>
export type MarketPublicControllerGetPricesQueryError = unknown


export function useMarketPublicControllerGetPrices<TData = Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError = unknown>(
 params: undefined |  MarketPublicControllerGetPricesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketPublicControllerGetPrices>>,
          TError,
          Awaited<ReturnType<typeof marketPublicControllerGetPrices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketPublicControllerGetPrices<TData = Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError = unknown>(
 params?: MarketPublicControllerGetPricesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketPublicControllerGetPrices>>,
          TError,
          Awaited<ReturnType<typeof marketPublicControllerGetPrices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketPublicControllerGetPrices<TData = Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError = unknown>(
 params?: MarketPublicControllerGetPricesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary PUBLIC: indicative price band per (product, grade)
 */

export function useMarketPublicControllerGetPrices<TData = Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError = unknown>(
 params?: MarketPublicControllerGetPricesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPrices>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMarketPublicControllerGetPricesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Buyer/admin only. buyer_user_id is the JWT sub. Quantities are numeric kg strings; priceZarpPerKgMicro is micro-ZARP/kg as a string. Status starts open.
 * @summary Create a buyer demand
 */
export const marketControllerCreateDemand = (
    createDemandDto: CreateDemandDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BuyerDemandDto>(
      {url: `/market/demands`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDemandDto, signal
    },
      );
    }
  


export const getMarketControllerCreateDemandMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketControllerCreateDemand>>, TError,{data: CreateDemandDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof marketControllerCreateDemand>>, TError,{data: CreateDemandDto}, TContext> => {

const mutationKey = ['marketControllerCreateDemand'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketControllerCreateDemand>>, {data: CreateDemandDto}> = (props) => {
          const {data} = props ?? {};

          return  marketControllerCreateDemand(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketControllerCreateDemandMutationResult = NonNullable<Awaited<ReturnType<typeof marketControllerCreateDemand>>>
    export type MarketControllerCreateDemandMutationBody = CreateDemandDto
    export type MarketControllerCreateDemandMutationError = unknown

    /**
 * @summary Create a buyer demand
 */
export const useMarketControllerCreateDemand = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketControllerCreateDemand>>, TError,{data: CreateDemandDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketControllerCreateDemand>>,
        TError,
        {data: CreateDemandDto},
        TContext
      > => {

      const mutationOptions = getMarketControllerCreateDemandMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Buyer/admin/coop_admin. Returns demands with the given status, newest first.
 * @summary List buyer demands by status (default open)
 */
export const marketControllerListDemands = (
    params?: MarketControllerListDemandsParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BuyerDemandListDto>(
      {url: `/market/demands`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getMarketControllerListDemandsQueryKey = (params?: MarketControllerListDemandsParams,) => {
    return [
    `/market/demands`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMarketControllerListDemandsQueryOptions = <TData = Awaited<ReturnType<typeof marketControllerListDemands>>, TError = unknown>(params?: MarketControllerListDemandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerListDemands>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketControllerListDemandsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketControllerListDemands>>> = ({ signal }) => marketControllerListDemands(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketControllerListDemands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MarketControllerListDemandsQueryResult = NonNullable<Awaited<ReturnType<typeof marketControllerListDemands>>>
export type MarketControllerListDemandsQueryError = unknown


export function useMarketControllerListDemands<TData = Awaited<ReturnType<typeof marketControllerListDemands>>, TError = unknown>(
 params: undefined |  MarketControllerListDemandsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerListDemands>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketControllerListDemands>>,
          TError,
          Awaited<ReturnType<typeof marketControllerListDemands>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketControllerListDemands<TData = Awaited<ReturnType<typeof marketControllerListDemands>>, TError = unknown>(
 params?: MarketControllerListDemandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerListDemands>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketControllerListDemands>>,
          TError,
          Awaited<ReturnType<typeof marketControllerListDemands>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketControllerListDemands<TData = Awaited<ReturnType<typeof marketControllerListDemands>>, TError = unknown>(
 params?: MarketControllerListDemandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerListDemands>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List buyer demands by status (default open)
 */

export function useMarketControllerListDemands<TData = Awaited<ReturnType<typeof marketControllerListDemands>>, TError = unknown>(
 params?: MarketControllerListDemandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerListDemands>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMarketControllerListDemandsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Coop_admin/admin. Coop-scoped to the batch's cooperative (404 otherwise; admin bypasses). Scores every open demand for the batch's product (defaults to "mango" — batches have no product column yet) and returns them sorted by score desc with the qtyFit/priceFit/recency/proximity breakdown.
 * @summary Score open demands against a batch
 */
export const marketControllerGetMatches = (
    batchId: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MatchListDto>(
      {url: `/market/matches/${batchId}`, method: 'GET', signal
    },
      );
    }
  



export const getMarketControllerGetMatchesQueryKey = (batchId?: string,) => {
    return [
    `/market/matches/${batchId}`
    ] as const;
    }

    
export const getMarketControllerGetMatchesQueryOptions = <TData = Awaited<ReturnType<typeof marketControllerGetMatches>>, TError = unknown>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerGetMatches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketControllerGetMatchesQueryKey(batchId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketControllerGetMatches>>> = ({ signal }) => marketControllerGetMatches(batchId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(batchId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketControllerGetMatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MarketControllerGetMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof marketControllerGetMatches>>>
export type MarketControllerGetMatchesQueryError = unknown


export function useMarketControllerGetMatches<TData = Awaited<ReturnType<typeof marketControllerGetMatches>>, TError = unknown>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerGetMatches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketControllerGetMatches>>,
          TError,
          Awaited<ReturnType<typeof marketControllerGetMatches>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketControllerGetMatches<TData = Awaited<ReturnType<typeof marketControllerGetMatches>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerGetMatches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketControllerGetMatches>>,
          TError,
          Awaited<ReturnType<typeof marketControllerGetMatches>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketControllerGetMatches<TData = Awaited<ReturnType<typeof marketControllerGetMatches>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerGetMatches>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Score open demands against a batch
 */

export function useMarketControllerGetMatches<TData = Awaited<ReturnType<typeof marketControllerGetMatches>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketControllerGetMatches>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMarketControllerGetMatchesQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Unauthenticated. Returns the raw observed micro-ZARP/kg points (oldest → newest) for a product over the last `days` days, plus the percent change from earliest to latest (null if <2 points) and the freshest observedAt. product defaults to "mango"; grade optional (A|B|C); days defaults to 30 (1..365). 400 on a bad grade or out-of-range days.
 * @summary PUBLIC: price time series per (product, grade) over a window
 */
export const marketPublicControllerGetPriceTimeSeries = (
    params?: MarketPublicControllerGetPriceTimeSeriesParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<PriceTimeSeriesDto>(
      {url: `/market/prices/timeseries`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getMarketPublicControllerGetPriceTimeSeriesQueryKey = (params?: MarketPublicControllerGetPriceTimeSeriesParams,) => {
    return [
    `/market/prices/timeseries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMarketPublicControllerGetPriceTimeSeriesQueryOptions = <TData = Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError = unknown>(params?: MarketPublicControllerGetPriceTimeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketPublicControllerGetPriceTimeSeriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>> = ({ signal }) => marketPublicControllerGetPriceTimeSeries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MarketPublicControllerGetPriceTimeSeriesQueryResult = NonNullable<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>>
export type MarketPublicControllerGetPriceTimeSeriesQueryError = unknown


export function useMarketPublicControllerGetPriceTimeSeries<TData = Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError = unknown>(
 params: undefined |  MarketPublicControllerGetPriceTimeSeriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>,
          TError,
          Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketPublicControllerGetPriceTimeSeries<TData = Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError = unknown>(
 params?: MarketPublicControllerGetPriceTimeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>,
          TError,
          Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMarketPublicControllerGetPriceTimeSeries<TData = Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError = unknown>(
 params?: MarketPublicControllerGetPriceTimeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary PUBLIC: price time series per (product, grade) over a window
 */

export function useMarketPublicControllerGetPriceTimeSeries<TData = Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError = unknown>(
 params?: MarketPublicControllerGetPriceTimeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketPublicControllerGetPriceTimeSeries>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMarketPublicControllerGetPriceTimeSeriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




